import { Component } from "react";

//COMPONENTS
import { NanoFlex } from "../../Elements/NanoFlex";
import Metric from "../../Elements/Map/Metric";

const metricsData = [
  {
    id: 1,
    value: "Temperature",
    color: "#2ADD9D",
  },
  {
    id: 2,
    value: "Humidity",
    color: "#2FBFDE",
  },
  {
    id: 3,
    value: "Air Quality",
    color: "#5E5CE6",
  },
  {
    id: 4,
    value: "Inactivity",
    color: "#FF80AB",
  },
  {
    id: 5,
    value: "Iluminance",
    color: "#FFDA67",
  },
  {
    id: 6,
    value: "Noise",
    color: "#8BC34A",
  },
  {
    id: 7,
    value: "Energy",
    color: "#167FFC",
  },
];

class Metrics extends Component {
  render() {
    return (
      <NanoFlex height="10vh">
        {metricsData.map((m, i) => {
          return (
            <Metric
              active={m.id === this.props.selectedMetric}
              key={`${i}_${m.id}`}
              id={m.id}
              value={m.value}
              color={m.color}
              onSelectMetric={(e) => this.props.onMetricChange(e)}
            ></Metric>
          );
        })}
      </NanoFlex>
    );
  }
}

export default Metrics;
